var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _subscriptions, _workflow;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet2(e, t) { var r = _classPrivateFieldGet(t, e); return _classApplyDescriptorGet(e, r); }
function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
function _classPrivateFieldSet(e, t, r) { var s = _classPrivateFieldGet(t, e); return _classApplyDescriptorSet(e, s, r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _classApplyDescriptorSet(e, t, l) { if (t.set) t.set.call(e, l);else { if (!t.writable) throw new TypeError("attempted to set read only private field"); t.value = l; } }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { Subscription, filter } from 'rxjs';
import Service, { inject as service } from '@ember/service';
import workflow, { ActionCreator as BalanceActionCreator, createState } from '@banking/ui/workflows/balance';
import { ActionCreator, ActionType } from '@banking/ui/workflows/balance/card-list';
import analytics from '@banking/ui/workflows/balance/analytics';
import routerTransitions from '@banking/ui/workflows/balance/router-transitions';
import { set } from '@ember/object';
import { updateLogger } from '@banking/ui/lib/workflow/update-logger';
import connect from '@banking/ui/lib/workflow-ember/connect';
import UUID from 'uuid-js';
import { updateOwnersAction } from '@banking/ui/workflows/unified-activity/unified-activity';
import { Screen, toggleModalByCardTokenAction } from '@banking/ui/workflows/debit-card-activation';
import { InitializationReason, initializeAction as initializeBillingAddressAction } from '@banking/ui/workflows/card-settings/billing-address';
import { hasViewedReplacementCardAddressPopup } from '@banking/ui/utils/replacement-card-address-popup';
const SERVICE_REGISTRY_KEY = 'unit-balance';
let UnitBalance = (_dec = service('bbfrontend/v1/card-list-service'), _dec2 = service('bbfrontend/v1/checking'), _dec3 = service('bbfrontend/v1/web'), _dec4 = service('bbfrontend/v1/printable-check'), _dec5 = service('card-management/billing-address'), _dec6 = service('bb-debit/card-management-service'), _class = (_subscriptions = /*#__PURE__*/new WeakMap(), _workflow = /*#__PURE__*/new WeakMap(), class UnitBalance extends Service {
  constructor(...args) {
    super(...args);
    _classPrivateFieldInitSpec(this, _subscriptions, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _workflow, {
      writable: true,
      value: void 0
    });
    _defineProperty(this, "state", createState());
    _initializerDefineProperty(this, "bankc", _descriptor, this);
    _initializerDefineProperty(this, "bizbankApi", _descriptor2, this);
    _initializerDefineProperty(this, "dataApi", _descriptor3, this);
    _initializerDefineProperty(this, "debitCardActivationModal", _descriptor4, this);
    _initializerDefineProperty(this, "features", _descriptor5, this);
    _initializerDefineProperty(this, "intl", _descriptor6, this);
    _initializerDefineProperty(this, "logEvents", _descriptor7, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor8, this);
    _initializerDefineProperty(this, "moneyOverview", _descriptor9, this);
    _initializerDefineProperty(this, "reporter", _descriptor10, this);
    _initializerDefineProperty(this, "router", _descriptor11, this);
    _initializerDefineProperty(this, "sentry", _descriptor12, this);
    _initializerDefineProperty(this, "userRailsPermissions", _descriptor13, this);
    _initializerDefineProperty(this, "bbFrontendV1CardListService", _descriptor14, this);
    _initializerDefineProperty(this, "bbFrontendV1CheckingService", _descriptor15, this);
    _initializerDefineProperty(this, "bbFrontendV1WebService", _descriptor16, this);
    _initializerDefineProperty(this, "bbFrontendV1PrintableCheckService", _descriptor17, this);
    _initializerDefineProperty(this, "billingAddressState", _descriptor18, this);
    _initializerDefineProperty(this, "cardManagementService", _descriptor19, this);
    _classPrivateFieldSet(this, _subscriptions, new Subscription());
    _classPrivateFieldSet(this, _workflow, workflow(this.context, createState()));
    _classPrivateFieldGet2(this, _subscriptions).add(_classPrivateFieldGet2(this, _workflow).states.subscribe({
      next: state => set(this, 'state', state),
      error: error => this.sentry.captureException(error)
    }));
    _classPrivateFieldGet2(this, _subscriptions).add(_classPrivateFieldGet2(this, _workflow).updates.subscribe(updateLogger('Unit Balance Page')));

    // cdp logging side-effects
    _classPrivateFieldGet2(this, _subscriptions).add(_classPrivateFieldGet2(this, _workflow).updates.pipe(analytics).subscribe(event => this.dataApi.track(...event)));

    // router transition side-effects
    _classPrivateFieldGet2(this, _subscriptions).add(_classPrivateFieldGet2(this, _workflow).updates.pipe(routerTransitions).subscribe(routeArgs =>
    // FIXME(steckel): Use TypeScript parameter inference once overloaded functions
    // are supported (https://github.com/microsoft/TypeScript/issues/32164)
    this.router.transitionTo(...routeArgs)));
    // If there is an expiring card with replacement due date, show the address confirmation
    // popup if they haven't seen it before
    _classPrivateFieldGet2(this, _subscriptions).add(_classPrivateFieldGet2(this, _workflow).updates.pipe(filter(([[before, next], action]) => action.type === ActionType.CardListReceived && !before.cardListState.cardTokenWithReplacementDueDate && Boolean(next.cardListState.cardTokenWithReplacementDueDate))).subscribe(([[_, next]]) => {
      const expiringCardToken = next.cardListState.cardTokenWithReplacementDueDate;
      if (expiringCardToken) {
        this.openBillingAddressModalForAddressConfirmation(next.unitToken, expiringCardToken);
      }
    }));
  }
  willDestroy() {
    _classPrivateFieldGet2(this, _subscriptions).unsubscribe();
    super.willDestroy();
  }
  emit(action) {
    _classPrivateFieldGet2(this, _workflow).emit(action);
  }
  initialize(unitToken, showPrintableCheckModal) {
    this.emit(BalanceActionCreator.systemInitialize(unitToken, showPrintableCheckModal));
  }
  openCardActivationModal(unitToken, cardToken) {
    this.debitCardActivationModal.emit(toggleModalByCardTokenAction(true, unitToken, cardToken));
  }
  closeCardActivationModal() {
    if (this.debitCardActivationModal.currentScreen === Screen.SUCCESS) {
      // refetch card list data after card is activated
      this.emit(ActionCreator.requestCardList());
    }
    this.debitCardActivationModal.emit(toggleModalByCardTokenAction(false));
  }
  openBillingAddressModalForAddressConfirmation(unitToken, expiringCardToken) {
    if (this.features.isEnabled('banking-show-replacement-card-address-confirmation-popup') && !hasViewedReplacementCardAddressPopup(expiringCardToken)) {
      this.billingAddressState.emit(initializeBillingAddressAction({
        expiringCardToken,
        unitToken,
        reason: InitializationReason.OPEN_CONFIRM_REPLACEMENT_CARD_ADDRESS_POPUP
      }));
    }
  }
  get states() {
    return _classPrivateFieldGet2(this, _workflow).states;
  }
  get context() {
    return {
      allowMultipleCards: this.features.isEnabled('bizbank/allow_square_card_multiple_cards'),
      allowOwnerOrderAdditionalDebitCards: this.features.isEnabled('banking/allow_owner_order_additional_debit_cards'),
      getCardList: this.bbFrontendV1CardListService.client.getCardList.bind(this.bbFrontendV1CardListService.client),
      getCheckingDirectDepositAccount: this.bbFrontendV1CheckingService.client.getCheckingDirectDepositAccount.bind(this.bbFrontendV1CheckingService.client),
      bootstrapCreatePrintableCheck: this.bbFrontendV1PrintableCheckService.client.bootstrapCreatePrintableCheck.bind(this.bbFrontendV1PrintableCheckService.client),
      canSeeBillPay: this.userRailsPermissions.shouldSeeBillPayApplet,
      canBypass2FA: this.features.isEnabled('banking/allow_view_account_number_bypass_2fa'),
      createPrintableCheck: this.bbFrontendV1PrintableCheckService.client.createPrintableCheck.bind(this.bbFrontendV1PrintableCheckService.client),
      createUserAuthorization: this.bizbankApi.client.createUserAuthorization.bind(this.bizbankApi.client),
      doMoreCardEnabled: this.features.isEnabled('banking/rollout_unit_balance_do_more_with_money'),
      downloadPrintableCheck: this.bbFrontendV1PrintableCheckService.client.downloadPrintableCheck.bind(this.bbFrontendV1PrintableCheckService.client),
      getBillPayData: this.bbFrontendV1WebService.client.getBillPayData.bind(this.bbFrontendV1WebService.client),
      getPrintableCheckAccess: this.bbFrontendV1PrintableCheckService.client.getPrintableCheckAccess.bind(this.bbFrontendV1PrintableCheckService.client),
      getUUIDString: () => UUID.create().toString(),
      listBalanceInstruments: this.bankc.externalBalanceProxyService.listBalanceInstruments.bind(this.bankc.externalBalanceProxyService),
      logEvents: this.logEvents,
      marketToasts: this.marketToasts,
      refreshBalances: unitToken => {
        this.moneyOverview.getBalances(unitToken, null, true);
      },
      refreshRecentActivities: unitToken => {
        this.reporter.emit(updateOwnersAction(unitToken));
      },
      retrieveCardRelationships: this.cardManagementService.client.retrieveCardRelationships.bind(this.cardManagementService.client),
      sentry: this.sentry,
      startTwoFactorAuthentication: this.bizbankApi.client.startTwoFactorAuthentication.bind(this.bizbankApi.client),
      showBillPayModal: this.features.isEnabled('banking/access_bill_pay'),
      showPrintableCheck: this.features.isEnabled('banking/access_write_check'),
      showStatements: this.features.isEnabled('banking/access_statements'),
      translate: key => this.intl.t(key)
    };
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "bankc", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bizbankApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "debitCardActivationModal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "logEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "moneyOverview", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "reporter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "userRailsPermissions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1CardListService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1CheckingService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1WebService", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "bbFrontendV1PrintableCheckService", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "billingAddressState", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "cardManagementService", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { UnitBalance as default };
export const workflowComponent = connect(SERVICE_REGISTRY_KEY);